import apiService from "../../../../service/Api";
import { NotificationGroup } from "../types/types";

export async function fetchGroupOptions(): Promise<NotificationGroup[]> {
  const res = await apiService.get<{ results: NotificationGroup[] }>(
    "/api/authentication/groups/?page_size=50",
  );
  return res.data.results;
}
